import(/* webpackMode: "eager" */ "/app/src/app/[locale]/book/page.tsx");
